import { Component, Input, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { Investor } from './../../../../../_models';
import { TableController } from './../../../../../_models/Classes/table-controller';

@Component({
    selector: 'app-investor-table',
    templateUrl: './investor-table.component.html',
    styleUrls: ['./investor-table.component.scss']
})
export class InvestorTableComponent extends TableController {
    @Input() tableMessages =
    {
        // Message to show when array is presented
        // but contains no values
        emptyMessage: 'No hay propietarios',

        // Footer total message
        totalMessage: ''
    };
    total: number = 0;
    constructor(
        private _domSanitizer: DomSanitizer,
        private data: Investor
    ) {
        super();
        this.data.sanitizer = _domSanitizer;
    }

    getData(params?: string) {
        return this.data.search(params).map(data => {
            this.total = this.data.page.total;
            return data;
        });
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/investor/investor-table/investor-table.component.ts